<script setup lang="ts">
	import { provideApolloClients } from '@vue/apollo-composable'
	import type { RouteLocationNormalized } from 'vue-router'

	provideApolloClients(useApollo().clients ?? {})

	// Прелоадер закомментирован
	// const { initPreloader } = useVideoPreloader()

	onMounted(() => {
		// initPreloader()
		// Сразу добавляем класс loaded без прелоадера
		document.body.classList.add('loaded')
	})
</script>

<template>
	<!-- Прелоадер закомментирован -->
	<!-- <UIPreloader /> -->
	<NuxtLayout>
		<NuxtPage :page-key="(route: RouteLocationNormalized) => route.path" />
	</NuxtLayout>
</template>
